module.exports = __webpack_public_path__ + "img/ner_no.f004f64d.png";